import type { StripeElementsOptions } from '@stripe/stripe-js';

export const stripeElementsOptions: StripeElementsOptions = {
  locale: 'fr',
  fonts: [
    {
      family: 'Averta',
      src: 'url(@insify/design-system/typography/fonts/AvertaPE-Regular.woff2)',
      weight: '400',
    },
  ],
  appearance: {
    theme: 'stripe',
    variables: {
      fontFamily: 'Averta, sans-serif',
      fontSizeBase: '15px',
      colorPrimary: '#0040e3',
      colorText: '#000000',
      colorDanger: '#f3073d',
      colorDangerText: '#f3073d',
      colorTextPlaceholder: 'rgba(0, 0, 0, 0.25)',
      spacingGridRow: '24px',
      spacingGridColumn: '24px',
      borderRadius: '5px',
    },
    rules: {
      '.Input': {
        border: '1px solid #dbdbdb',
        boxShadow: 'none',
        lineHeight: '46px',
        padding: '0 16px',
      },
      '.Input:focus': {
        borderColor: '#0040e3',
        outline: 'none',
        boxShadow: 'none',
      },
      '.Input--invalid': {
        border: '1px solid #f3073d',
        borderBottomLeftRadius: '0px',
        borderBottomRightRadius: '0px',
        outline: 'none',
        boxShadow: 'none',
      },
      '.Input--invalid:focus': {
        borderColor: '#f3073d',
        outline: 'none',
        boxShadow: 'none',
      },
      '.Label': {
        fontWeight: 'bold',
      },
      '.Error': {
        marginTop: '0',
        padding: '4px 4px 6px 16px',
        backgroundColor: '#f3073d',
        borderBottomLeftRadius: '5px',
        borderBottomRightRadius: '5px',
        color: '#fff',
        fontSize: '12px',
      },
    },
  },
};
